export default "__VITE_ASSET__DrrTPenF__"